import React, {Component} from 'react';
import Cookies from 'universal-cookie';
import * as _ from 'lodash';
import {Button, Form, Input, notification, Layout} from "antd";

import {withTranslation} from "react-i18next";
import UserService from "../../apiServices/UserService";
import "../../App.css"
import {Link} from "react-router-dom";

const cookies = new Cookies();

const { Header, Footer, Content } = Layout;

class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        const resetKey = urlParams.get('reset_key');

        this.state = {
            loading: false,
            resetKey: resetKey,
        }
    }

    componentDidMount() {
        const access_token = cookies.get('access_token');
        if(access_token) {
            this.props.history.push('/');
        }
    }

    onSubmit = (e) => {
        e.preventDefault();
        const {form} = this.props;
        form.validateFields((error, values) => {
            if(!error) {
                const {password, confirm_password} = values;
                if (password !== confirm_password){
                    notification['error']({
                        message: 'Mật khẩu và Xác nhận mật khẩu không giống nhau',
                        description: '',
                    });
                }else{
                    UserService.resetPassword(this.state.resetKey, password).then(response => {
                        notification['success']({
                            message: 'Bạn đã tạo mật khẩu mới thành công',
                            description: 'Sử dụng mật khẩu mới để đăng nhập',
                        });
                        this.props.history.push('/');
                    }).catch(error => {
                        notification.error({
                            message: error,
                            description: _.get(error, 'response.message', 'Error'),
                        });
                    })
                }
            }
        });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div className={'main-login'}>
                <Header className={"header"}>
                </Header>
                <Content>
                    <h1 className="header-logo">INSUNOW</h1>
                    <Form onSubmit={this.onSubmit} className="register-form">
                        <Form.Item label={'Mật khẩu mới'}>
                            {getFieldDecorator('password', {
                                rules: [
                                    {required: true, message: 'Vui lòng nhập Mật khẩu mới'}
                                ]
                            })(
                                <Input type="password" placeholder={'Mật khẩu mới'} />
                            )}
                        </Form.Item>
                        <Form.Item label={'Xác nhận mật khẩu mới'}>
                            {getFieldDecorator('confirm_password', {
                                rules: [
                                    {required: true, message: 'Vui lòng nhập Xác nhận mật khẩu mới'}
                                ]
                            })(
                                <Input type="password" placeholder={'Xác nhận mật khẩu mới'} />
                            )}
                        </Form.Item>
                        <Form.Item className="form-item-submit">
                            <Button
                                type="primary"
                                htmlType="submit"
                            >
                                {'Tạo mật khẩu mới'}
                            </Button>
                        </Form.Item>
                        <Form.Item>
                            Quay lại trang <Link to='/login'>Đăng nhập</Link>
                        </Form.Item>
                    </Form>
                </Content>
                <Footer style={{backgroundColor: '#ea8025'}}>&copy;2019</Footer>
            </div>
        )
    }
}

ForgotPassword = Form.create()(ForgotPassword);

export default (withTranslation())(ForgotPassword);